import { useSnapshot } from 'valtio';
import TopBarStore from '../stores/top-bar-store';

export const useDateRange = () => {
  const { dateRange } = useSnapshot(TopBarStore);
  return dateRange;
};
